var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

const SvgUpArrow = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.71 12.2871L12.71 7.28707C12.6149 7.19603 12.5028 7.12467 12.38 7.07707C12.1365 6.97706 11.8635 6.97706 11.62 7.07707C11.4973 7.12467 11.3851 7.19603 11.29 7.28707L6.29 12.2871C6.19676 12.3803 6.1228 12.491 6.07234 12.6128C6.02188 12.7346 5.99591 12.8652 5.99591 12.9971C5.99591 13.2634 6.1017 13.5188 6.29 13.7071C6.47831 13.8954 6.7337 14.0012 7 14.0012C7.2663 14.0012 7.5217 13.8954 7.71 13.7071L11 10.4071V17.9971C11 18.2623 11.1054 18.5166 11.2929 18.7042C11.4804 18.8917 11.7348 18.9971 12 18.9971C12.2652 18.9971 12.5196 18.8917 12.7071 18.7042C12.8946 18.5166 13 18.2623 13 17.9971V10.4071L16.29 13.7071C16.383 13.8008 16.4936 13.8752 16.6154 13.926C16.7373 13.9767 16.868 14.0029 17 14.0029C17.132 14.0029 17.2627 13.9767 17.3846 13.926C17.5064 13.8752 17.617 13.8008 17.71 13.7071C17.8037 13.6141 17.8781 13.5035 17.9289 13.3817C17.9797 13.2598 18.0058 13.1291 18.0058 12.9971C18.0058 12.8651 17.9797 12.7344 17.9289 12.6125C17.8781 12.4906 17.8037 12.38 17.71 12.2871Z",
    fill: "#0058A3"
  })));
};

const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgUpArrow, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/UpArrow.82539977.svg";
export { ForwardRef as ReactComponent };